<template>
  <LcButton
    v-bind="{ ...$attrs, ...$props }"
    class="quantity-button"
    size="medium"
    variant="secondary"
  />
</template>

<script lang="ts" setup>
import type { LcButtonProps, LcIconName } from '@lottocom/frontend-components'

type ScratchcardQuantityButtonProps = Pick<LcButtonProps, 'disabled'> & {
  icon: Extract<LcIconName, 'minus' | 'plus'>
}

defineProps<ScratchcardQuantityButtonProps>()
</script>

<style lang="scss" scoped>
.quantity-button {
  border: token('size/border/100') solid token('color/border/primary/primary');
  border-radius: token('size/radius/l');
  background: token('color/background/accent/info/info/extralight');
  color: token('color/icon/primary/primary');

  @include hover-state {
    border-color: token('color/border/accent/fade/fade/hovered');
  }

  &:disabled {
    border-color: token('color/background/secondary/secondary/disabled');
    background: none;
    color: token('color/icon/primary/primary/disabled');
  }
}
</style>
